/**
 * Определение типа отдела пользователя по companyId
 * 
 * Типы отделов:
 * - SALES: отдел продаж/менеджеры
 * - PRODUCTION: производство
 * - ASSEMBLY: сборка
 * - DELIVERY: доставка
 * - INSTALLATION: монтаж
 */

// Известные ID компаний-отделов
const DEPARTMENT_COMPANIES = {
  PRODUCTION: ['77087244502'],
  ASSEMBLY: ['77471020567'],
  DELIVERY: ['77775288660'],
  INSTALLATION: ['INSTALLATION_COMPANY_ID'], // TODO: добавить реальный ID монтажа
};

/**
 * Определяет тип отдела по companyId
 * @param {string} companyId - ID компании пользователя
 * @returns {string} Тип отдела: 'SALES' | 'PRODUCTION' | 'ASSEMBLY' | 'DELIVERY' | 'INSTALLATION'
 */
export const getDepartmentType = (companyId) => {
  if (!companyId) {
    return 'SALES'; // По умолчанию - продажи
  }

  // Проверяем производство
  if (DEPARTMENT_COMPANIES.PRODUCTION.includes(companyId)) {
    return 'PRODUCTION';
  }

  // Проверяем сборку
  if (DEPARTMENT_COMPANIES.ASSEMBLY.includes(companyId)) {
    return 'ASSEMBLY';
  }

  // Проверяем доставку
  if (DEPARTMENT_COMPANIES.DELIVERY.includes(companyId)) {
    return 'DELIVERY';
  }

  // Проверяем монтаж
  if (DEPARTMENT_COMPANIES.INSTALLATION.includes(companyId)) {
    return 'INSTALLATION';
  }

  // Если не найден ни один из известных отделов - считаем что это продажи
  return 'SALES';
};

/**
 * Проверяет, относится ли пользователь к отделу продаж
 * @param {string} companyId - ID компании пользователя
 * @returns {boolean}
 */
export const isSalesDepartment = (companyId) => {
  return getDepartmentType(companyId) === 'SALES';
};

/**
 * Проверяет, относится ли пользователь к производственным отделам
 * @param {string} companyId - ID компании пользователя
 * @returns {boolean}
 */
export const isProductionDepartment = (companyId) => {
  const type = getDepartmentType(companyId);
  return ['PRODUCTION', 'ASSEMBLY', 'DELIVERY', 'INSTALLATION'].includes(type);
};

/**
 * Получает читаемое название отдела
 * @param {string} departmentType - Тип отдела
 * @returns {string} Название отдела на русском
 */
export const getDepartmentName = (departmentType) => {
  const names = {
    SALES: 'Отдел продаж',
    PRODUCTION: 'Производство',
    ASSEMBLY: 'Сборка',
    DELIVERY: 'Доставка',
    INSTALLATION: 'Монтаж',
  };

  return names[departmentType] || 'Неизвестный отдел';
};

